<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <nav
    class="navbar navbar-expand-lg fixed-top"
    :class="[
      { 'navbar--open': this.navbarOpen },
      { 'navbar--open--scroll': isScrolled },
      NavBarCustomClasses,
    ]"
    v-if="$store.state.header"
  >
    <div class="ts-container-fluid container-fluid">
      <!-- For LTR -->
      <router-link
        class="navbar-brand d-flex fw-bold ts-text-gray-5"
        to="/"
        @click="closeNavbar"
        :class="$store.state.isRtl ? 'd-none' : ''"
      >
        <div class="d-none d-sm-block">
          <img
            width="107"
            :src="
              $store.state.baseUrl +
              $store.state.header.logoLarge.data.attributes.url
            "
            :alt="$store.state.header.logoLarge.data.attributes.alternativeText"
          />
        </div>
        <div class="d-sm-none">
          <img
            width="36"
            :src="
              $store.state.baseUrl +
              $store.state.header.logoSmall.data.attributes.url
            "
            :alt="$store.state.header.logoLarge.data.attributes.alternativeText"
          />
        </div>
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleNavbar"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <!-- For LTR -->
      <router-link
        class="navbar-brand d-flex fw-bold ts-text-gray-5"
        to="/"
        @click="closeNavbar"
        :class="$store.state.isRtl ? 'd-lg-none' : 'd-none'"
      >
        <div class="d-none d-sm-block">
          <img
            width="107"
            :src="
              $store.state.baseUrl +
              $store.state.header.logoLarge.data.attributes.url
            "
            :alt="$store.state.header.logoLarge.data.attributes.alternativeText"
          />
        </div>
        <div class="d-sm-none">
          <img
            width="36"
            :src="
              $store.state.baseUrl +
              $store.state.header.logoSmall.data.attributes.url
            "
            :alt="$store.state.header.logoLarge.data.attributes.alternativeText"
          />
        </div>
      </router-link>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul
          class="navbar-nav mb-2 mb-lg-0"
          :class="$store.state.isRtl ? 'pe-0' : 'ms-auto'"
        >
          <li
            class="nav-item dropdown mb-3 mb-lg-0"
            v-for="dropdown in $store.state.header.DropDown"
            :key="dropdown.id"
            @mouseenter="handleHoverEnter(dropdown.id)"
            @mouseleave="handleHoverLeave"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              aria-expanded="false"
            >
              {{ dropdown.title }}
            </a>
            <ul
              class="dropdown-menu"
              :class="{
                show:
                  isDropDwonOpen ||
                  (isLargeScreen && hoveredDropdown === dropdown.id),
              }"
            >
              <!-- class="dropdown-item nav-link--active" -->
              <li v-for="item in dropdown.DropdownItem" :key="item.id">
                <CustomLinkNav
                  class="dropdown-item"
                  :toSrc="item.to"
                  :text="item.text"
                  @click="closeNavbar"
                >
                </CustomLinkNav>
              </li>
            </ul>
          </li>
          <li
            class="nav-item"
            v-for="pageLink in $store.state.header.PageLink"
            :key="pageLink.id"
          >
            <router-link
              class="nav-link"
              :to="'/' + pageLink.to"
              @click="closeNavbar"
            >
              {{ pageLink.text }}
            </router-link>
          </li>
          <!--
          <li class="nav-item dropdown language-dropdown">
            <img src="/icons/globe.svg" width="25px" alt="" />
            <a
              class="dropdown-toggle"
              :class="{ 'active-language-style': isArabicActive }"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ activeLanguageName }}
            </a>
            <ul class="dropdown-menu" :class="{ show: isDropDwonOpen }">
              
              <li
                v-for="language in displayLanguages"
                :key="language.code"
                class="dropdown-item"
                @click="
                  () => {
                    this.$store.dispatch('switchLanguge', language.code);
                    if (language.code === 'ar') {
                      this.$store.dispatch('setIsRtl', true);
                    } else {
                      this.$store.dispatch('setIsRtl', false);
                    }
                    closeNavbar();
                  }
                "
              >
                <div class="language-dropdown-item">
                  <img
                    :src="language.flagsource"
                    width="25px"
                    alt="Language flag"
                  />
                  <a href="#">
                    {{ language.name }}
                  </a>
                </div>
              </li>
            </ul>
          </li>
          <li>
            <ul
              class="languages-container"
              :class="{ 'languages-container--rtl': $store.state.isRtl }"
            >
              <li
                v-for="language in displayLanguages"
                :key="language.code"
                :class="'language-item-' + language.code"
                @click="
                  () => {
                    this.$store.dispatch('switchLanguge', language.code);
                    if (language.code === 'ar') {
                      this.$store.dispatch('setIsRtl', true);
                    } else {
                      this.$store.dispatch('setIsRtl', false);
                    }
                    closeNavbar();
                  }
                "
              >
                <div :class="'language-text-' + language.code">
                  {{ language.name }}
                </div>
                <img src="/icons/globe.svg" width="25px" alt="" />
              </li>
            </ul>
          </li>  
          Old
          -->
          <li class="nav-item d-flex align-items-center">
            <div
              class="dropdown"
              :class="{ 'languages-container--rtl': $store.state.isRtl }"
            >
              <!--
              <a
                class="dropdown-toggle ts-btn rounded-2 language-flags-dropdown"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img src="/images/globe.svg" width="25" alt="" />
                <div class="active-language-class">
                  {{ activeLanguageName }}
                </div>
              </a>
              <ul class="dropdown-menu">
                <li
                  v-for="language in displayLanguages"
                  :key="language.code"
                  @click="
                    () => {
                      this.$store.dispatch('switchLanguge', language.code);
                      if (language.code === 'ar') {
                        this.$store.dispatch('setIsRtl', true);
                      } else {
                        this.$store.dispatch('setIsRtl', false);
                      }
                      closeNavbar();
                    }
                  "
                > -->
              <!-- v-if="language.code !== 'ar'" -->
              <!-- v-if="language.code !== 'ar'" -->
              <!--
                  <a class="language-flags-dropdown-items" href="#">
                    <img
                      :src="language.flagsource"
                      width="22"
                      alt="Language flag"
                    />
                    <div>{{ language.name }}</div>
                  </a>
                </li>
              </ul>
              -->
            </div>
          </li>
        </ul>
      </div>
      <!-- For RTL -->
      <router-link
        class="navbar-brand d-flex fw-bold ts-text-gray-5"
        to="/"
        @click="closeNavbar"
        :class="$store.state.isRtl ? 'd-none d-lg-block' : 'd-none'"
      >
        <div class="d-none d-sm-block">
          <img
            width="107"
            :src="
              $store.state.baseUrl +
              $store.state.header.logoLarge.data.attributes.url
            "
            :alt="$store.state.header.logoLarge.data.attributes.alternativeText"
          />
        </div>
        <div class="d-sm-none">
          <img
            width="36"
            :src="
              $store.state.baseUrl +
              $store.state.header.logoSmall.data.attributes.url
            "
            :alt="$store.state.header.logoLarge.data.attributes.alternativeText"
          />
        </div>
      </router-link>
    </div>
  </nav>
</template>

<script>
import CustomLinkNav from "../Helpers/CustomLinkNav.vue";
export default {
  name: "TsNavbar",
  components: {
    CustomLinkNav,
  },
  props: {
    NavBarCustomClasses: String,
  },

  // Api Calling Start
  computed: {
    activeLanguage() {
      return this.$store.getters.activeLanguage;
    },
    activeLanguageName() {
      const activeLanguage = this.$store.getters.activeLanguage;
      const activeLang = this.displayLanguages.find(
        (language) => language.code === activeLanguage
      );

      if (activeLang) {
        return activeLang.name === "Arabic" ? "عربي" : activeLang.name;
      }

      return null;
    },
    isArabicActive() {
      const activeLanguage = this.$store.getters.activeLanguage;
      return activeLanguage === "ar";
    },
    desiredLanguages() {
      return this.$store.state.languages;
    },
    displayLanguages() {
      const order = ["English", "Arabic", "Italian"];

      const sortedLanguages = this.desiredLanguages.map((language) => {
        let flagsource = "";
        let name = language.name;
        const index = name.indexOf(" (");
        if (index !== -1) {
          name = name.substring(0, index);
        }
        if (name === "Arabic") {
          flagsource = "/images/Languages/UAE.png";
        } else if (name === "English") {
          flagsource = "/images/Languages/USA.png";
        } else if (name === "Italian") {
          flagsource = "/images/Languages/italy.png";
        }
        return {
          ...language,
          name: name,
          flagsource: flagsource,
        };
      });

      return sortedLanguages.sort((a, b) => {
        return order.indexOf(a.name) - order.indexOf(b.name);
      });
    },
    nonActiveLanguages() {
      return this.displayLanguages.filter(
        (language) => language.code !== this.activeLanguage
      );
    },
  },

  watch: {
    activeLanguage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$store.dispatch("getHeader");
      }
    },
  },
  created() {
    this.$store.dispatch("getHeader");
  },

  // Api Calling End

  data: function () {
    return {
      /*languages: [
        { code: "ar", name: "عربي" },
        { code: "en", name: "English" },
      ],*/
      navbarOpen: false,
      isScrolled: false,
      isDropDwonOpen: false,
      hoveredDropdown: null,
      Languages: null,
    };
  },
  methods: {
    handleHoverEnter(id) {
      // Set hover state only for large screens
      if (this.isLargeScreen) {
        this.hoveredDropdown = id;
        /*console.log(id);
        console.log(this.isLargeScreen && this.hoveredDropdown === id);
        console.log(
          this.isDropDwonOpen ||
            (this.isLargeScreen && this.hoveredDropdown === id)
        );*/
      }
    },
    handleHoverLeave() {
      // Remove hover state only for large screens
      if (this.isLargeScreen) {
        this.hoveredDropdown = null;
      }
    },
    isActive(route) {
      return this.$route.path === route;
    },

    toggleNavbar() {
      // Call your custom method here before toggling the Navbar
      this.handleNavbarToggle();
      // Toggle the Navbar
      this.isNavbarOpen = !this.isNavbarOpen;
    },
    handleNavbarToggle() {
      const navbar = document.querySelector(".navbar");
      const navbarToggler = document.querySelector(".navbar-toggler");
      if (navbarToggler && navbarToggler.classList.contains("collapsed")) {
        this.navbarOpen = false;
        document.body.classList.remove("body-overflow-hidden");
        navbar.classList.remove("navbar--open");
      } else {
        this.navbarOpen = true;
        navbar.classList.add("navbar--open");
        document.body.classList.add("body-overflow-hidden");
      }
    },
    handleScroll() {
      /* const navbar = document.querySelector(".navbar");
      navbar.classList.remove("navbar--open");*/
      if (window.scrollY > 50) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    },

    // Run A Function if screen resize or less then
    handleScreenResize() {
      const screenWidth = window.innerWidth;
      // Define the maximum screen width below which you want to run the function
      const maxScreenWidth = 991; // For example, 991px
      this.isLargeScreen = window.innerWidth > maxScreenWidth;
      if (screenWidth < maxScreenWidth) {
        this.isDropDwonOpen = true;
      } else {
        this.isDropDwonOpen = false;
      }
    },

    // Navbar closed after clicking on navlink
    closeNavbar() {
      const navbar = document.querySelector(".navbar");
      const navbarToggler = document.querySelector(".navbar-toggler");
      const navbarCollapse = document.querySelector(".navbar-collapse");

      this.isNavbarOpen = !this.isNavbarOpen;
      document.body.classList.remove("body-overflow-hidden");
      this.navbarOpen = false;
      navbar.classList.remove("navbar--open");
      // navbarToggler.classList.remove("collapsed")
      navbarToggler.setAttribute("aria-expanded", "false");
      navbarCollapse.classList.remove("show");
      this.handleScreenResize();
    },
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // Call the function on component mount to handle initial screen size
    window.addEventListener("resize", this.handleScreenResize);
    // Call the function on component mount to handle initial screen size
    this.handleScreenResize();

    // Getting Languages from Store
    this.$store.dispatch("getLnaguages");
  },
  // beforeUnmount() {
  //   window.removeEventListener("scroll", this.handleScroll);
  //   window.removeEventListener("resize", this.handleScreenResize);
  // },
};
</script>

<style lang="scss">
a {
  text-decoration: none !important;
}
.navbar {
  background-color: rgba(255, 255, 255, 0) !important;

  &--open {
    background-color: white !important;
  }

  &--open--scroll {
    background-color: white !important;
  }
  .ts-language-btn {
    background-color: #757575 !important;
    border-color: #757575 !important;
    line-height: 100%;
    padding: 4px 0.5625rem 3px;
  }
}
.ts-language-dropdown {
  width: 67px !important;
  min-width: 67px !important;
  ul,
  li {
    padding: 0;
  }
  .dropdown-menu {
    min-width: 67px !important;
    width: 67px !important;
  }
  .dropdown-item {
    font-size: 22px;
    padding-block: 4.75px !important;
    line-height: 100%;
  }
}

.rtl {
  @media (min-width: 992px) {
    .navbar-nav {
      flex-direction: row-reverse !important;
    }
  }
}
/* language dropdown */

.language-flags-dropdown {
  display: flex !important;
  align-items: center !important;
  padding: 8px 10px !important;
  width: fit-content;
  /* border: 2px solid #757575;
  background-color: rgba(117, 117, 117, 0.1);*/
  transition: 300ms ease-in-out;
  color: #353535;
  &:hover {
    color: #00a4b6;
  }
  @media (max-width: 768px) {
    min-width: 135px;
  }
}

.active-language-class {
  color: inherit;
}
.language-flags-dropdown-items {
  display: flex !important;
  align-items: center !important;
  gap: 15px;
  padding: 5px 10px;
  width: fit-content;
}

.language-flags-dropdown div {
  margin-left: 20px;
}
@media (max-width: 768px) {
  .dropdown-menu {
    min-width: 0 !important;
  }
}

/* languages styles */
.languages-container--rtl {
  margin-left: auto;
}
/*
.languages-container {
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0;
  width: 100%;
}
.languages-container li {
  cursor: pointer;
  background-color: #ffffff;
  height: 45px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  padding-right: 10px;
}

.language-item-en {
  width: 117px;
  font-size: 18px;
  align-items: center;
}
.language-item-ar {
  width: 95px;
  flex-direction: row-reverse !important;
  align-items: center;
  font-family: "Almarai", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 17px;
}

.language-text-ar {
  padding-bottom: 7px;
  color: #353535;
}
.language-text-en {
  color: #353535;
}

@media (max-width: 992px) {
  .languages-container li {
    background-color: #f5f5f5;
  }
}*/
</style>
